import { render, staticRenderFns } from "./Suspected.vue?vue&type=template&id=1274bdb1&"
import script from "./Suspected.vue?vue&type=script&lang=ts&"
export * from "./Suspected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1274bdb1')) {
      api.createRecord('1274bdb1', component.options)
    } else {
      api.reload('1274bdb1', component.options)
    }
    module.hot.accept("./Suspected.vue?vue&type=template&id=1274bdb1&", function () {
      api.rerender('1274bdb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/History/Suspected.vue"
export default component.exports